import PayrollSummEmpReportComponent from 'components/Report/PayrollSummEmpReport';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust path if needed

const PayrollSummaryEmployeeReport = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<PayrollSummEmpReportComponent />
		</PermissionGuard>
	);
};

export default PayrollSummaryEmployeeReport;
